import * as React from "react";
import { useTranslation } from "react-i18next";
import Undraw from "react-undraw";
import { colors } from "~/config/stitches/colors";
import { Box } from "~/design-system/Box";
import { Stack } from "~/design-system/Stack";
import { Text } from "~/design-system/Text";

const EmptyNotifications = () => {
  const { t } = useTranslation();

  return (
    <Box
      padding="gutter"
      css={{ alignItems: "center", display: "flex", height: "100%" }}
    >
      <Stack align="center" space="small">
        <Box
          style={{ maxHeight: "50vh", maxWidth: "50vw" }}
          width="full"
          height="full"
        >
          <Undraw name="empty" primaryColor={colors.emerald500} height="100%" />
        </Box>
        <Text>
          {t(
            "screens.UserNotificationsScreen.EmptyNotifications.noNotifications",
            "You don't have any notification to read"
          )}
        </Text>
      </Stack>
    </Box>
  );
};

export { EmptyNotifications };
